import React, { useContext, useEffect, useRef, useState } from 'react'

import { WappContext } from 'wapplr-react/dist/common/Wapp'
import AppContext from '../../../App/context'
import Select from 'karrierhub-ui/dist/common/src/components/Input/Select'
import Switch from 'karrierhub-ui/dist/common/src/components/Input/Switch'
import LightModeIcon from 'karrierhub-ui/dist/common/src/svg/LightModeIcon'
import AutoModeIcon from 'karrierhub-ui/dist/common/src/svg/AutoModeIcon'
import DarkModeIcon from 'karrierhub-ui/dist/common/src/svg/DarkModeIcon'
import ContrastIcon from 'karrierhub-ui/dist/common/src/svg/ContrastIcon'

export function ThemeControlsIcon(props) {

    const [mode, setMode] = useState(props.mode)

    useEffect(() => {
        if (props.effect) {
            props.effect({
                actions: {
                    setMode
                }
            })
        }
        return () => {
            if (props.effect) {
                props.effect({
                    actions: {
                        setMode: async () => {
                        }
                    }
                })
            }
        }
    })

    return mode === 'light' ? <LightModeIcon /> : mode === 'dark' ? <DarkModeIcon /> : <AutoModeIcon />
}

export function ThemeControlsBase({ classNames, themeRef, iconRef, ControlsProps = {}, size }) {

    const context = useContext(WappContext)
    const appContext = useContext(AppContext)
    const { res } = context

    const modeRef = useRef({})
    const themesRef = useRef({})

    // noinspection PointlessBooleanExpressionJS
    return (
        <div className={classNames.themeControls}>
            {
                false &&
                <Select
                    label={'Theme'}
                    size={size}
                    {...ControlsProps}
                    InputProps={{
                        menu: [
                            { label: 'Default theme', value: 'karrierhub' },
                            { label: 'Theme 2', value: 'theme2' }
                        ],
                        effect: ({ actions }) => {
                            themesRef.current.actions = actions
                        },
                        onBlur: async (e, value) => {
                            if (themeRef.current?.actions) {
                                if (!value[0]) {
                                    await themesRef.current.actions.setValue([res.wappResponse.store.getState('karrierhubUi.theme') || 'karrierhub'])
                                } else {
                                    themeRef.current.actions.setTheme(value[0])
                                    if (popoverRef.current.popper?.actions?.update) {
                                        await new Promise((resolve) => setTimeout(resolve, 500))
                                        if (popoverRef.current.popper?.actions?.update) {
                                            popoverRef.current.popper.actions.update()
                                        }
                                    }
                                }
                            }
                        }
                    }}
                    value={[res.wappResponse.store.getState('karrierhubUi.theme') || 'karrierhub']}
                />
            }
            <Switch
                label={appContext.labels.themeControlsMode}
                size={size}
                {...ControlsProps}
                InputProps={{
                    menu: [
                        { label: appContext.labels.themeControlsLightMode, value: 'light', endIcon: <LightModeIcon /> },
                        {
                            label: appContext.labels.themeControlsAutoMode,
                            secondaryText: appContext.labels.themeControlsAutoModeSec,
                            value: 'auto',
                            endIcon: <AutoModeIcon />
                        },
                        { label: appContext.labels.themeControlsDarkMode, value: 'dark', endIcon: <DarkModeIcon /> }
                    ],
                    effect: ({ actions }) => {
                        modeRef.current.actions = actions
                    },
                    onBlur: async (e, value) => {
                        if (themeRef.current?.actions) {
                            if (!value[0]) {
                                async function asyncFunction() {
                                    if (res.wappResponse.store.getState('karrierhubUi.mode') !== 'auto') {
                                        themeRef.current.actions.setMode('auto')
                                        if (iconRef.current.actions?.setMode) {
                                            iconRef.current.actions.setMode(value[0])
                                        }
                                    }
                                    await new Promise((resolve) => setTimeout(resolve, 300))
                                    await modeRef.current.actions.setValue(['auto'])
                                }

                                // noinspection ES6MissingAwait
                                asyncFunction()
                            } else {
                                if (iconRef.current.actions?.setMode) {
                                    iconRef.current.actions.setMode(value[0])
                                }
                                themeRef.current.actions.setMode(value[0])
                            }
                        }
                    },
                    MenuItemProps: {
                        className: classNames.themeControlsModeItems
                    }
                }}
                value={[res.wappResponse.store.getState('karrierhubUi.mode') || 'auto']}
                disableButtonPaper={true}
            />
            <Switch
                label={appContext.labels.themeControlsContrast}
                size={size}
                {...ControlsProps}
                InputProps={{
                    menu: [
                        {
                            label: appContext.labels.themeControlsHighContrast,
                            value: true,
                            endIcon: <ContrastIcon />
                        }
                    ],
                    onBlur: (e, value) => {
                        if (themeRef.current?.actions) {
                            themeRef.current.actions.setAutoContrast(!!(value[0]))
                        }
                    }
                }}
                value={res.wappResponse.store.getState('karrierhubUi.autoContrast') ? [true] : []}
            />
        </div>
    )
}
